
import { AlertTriangle } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

export const NotificationSection = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="border border-[#d97706]/40 bg-[#d97706]/10 p-6 rounded-xl mb-8 border-l-4 border-l-[#d97706]"
    >
      <h3 className="font-bold text-lg mb-3 flex items-center gap-2 text-[#d97706]">
        <AlertTriangle className="h-5 w-5" />
        {t('plans_detail.safety_net.notification.title')}
      </h3>
      <p className="mb-2 text-white/75 leading-relaxed">
        {t('plans_detail.safety_net.notification.body1')}
      </p>
      <p className="text-white/75">
        {t('plans_detail.safety_net.notification.body2')}
      </p>
    </motion.div>
  );
};
